
export class WindowOpener {
  constructor(window, navigator) {
    this.winRef = window
    this.navRef = navigator
    if (this._isSafari()) { this.newWin = window.open() }
  }

  open(fileURL) {
    if (this._isSafari()) {
      this.newWin.location.href = fileURL
    } else {
      this.winRef.open(fileURL)
    }
  }

  _isSafari () {
    return this.navRef.vendor && this.navRef.vendor.indexOf('Apple') > -1 &&
           this.navRef.userAgent &&
           this.navRef.userAgent.indexOf('CriOS') === -1 &&
           this.navRef.userAgent.indexOf('FxiOS') === -1
  }
}
